import { render } from "./OutSideTitleCard.vue?vue&type=template&id=742e6261"
import script from "./OutSideTitleCard.vue?vue&type=script&lang=js"
export * from "./OutSideTitleCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__